<template>
   <div
    id="lm-button-root-wrapper"
    class="form-group row"
    @click="stopPropagation"
    :class="[
      lmButtonRootWrapperClass,
      {'avoid-pointer-events': this.isProcessing}
      ]"
    >
    <div
      id="lm-button-wrapper"
      :class="[
          lmButtonWrapperClass,
          {'col-sm-10':!lmButtonWrapperClass}
        ]"
        @click="stopPropagation"
      >
      <button
        :id="id"
        ref="lmButton"
        :type="type"
        :disabled="isDisabled"
        :style="{width: buttonWidth, height: buttonHeight}"
        :class="[
          buttonClass,
          {'btn-info': !buttonClass && !disabled},
          {disabled: disabled}
        ]"
        class="btn d-flex justify-content-center"
        >
          <LmSpinnerBorder @click="stopPropagation" class="lm-spinner-border" v-if="isProcessing"/>
          <span @click="stopPropagation" :class="{invisible: isProcessing}">{{text}}</span>
        </button>
    </div>
    <b-tooltip @click="stopPropagation" v-if="showTooltip" target="lm-button-wrapper" placement="top">
      {{tooltip.value}}
    </b-tooltip>
  </div>
</template>

<script>
import LmSpinnerBorder from '@/components/LmSpinnerBorder'
export default {
  data () {
    return {
      buttonWidth: null,
      buttonHeight: null
    }
  },
  computed: {
    isDisabled () {
      return this.disabled || this.isProcessing
    },
    showTooltip () {
      if (this.tooltip) {
        if (this.tooltip.showOnlyOnDisabled && this.tooltip.value) {
          return this.disabled
        } else {
          return this.tooltip.value
        }
      }
    },
    text () {
      return this.value
    }
  },
  props: {
    value: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    buttonClass: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    tooltip: {
      type: Object
    },
    isProcessing: {
      type: Boolean,
      default: false
    },
    lmButtonWrapperClass: {
      type: String
    },
    lmButtonRootWrapperClass: {
      type: String
    },
    id: {
      type: String,
      default: 'lm-button'
    }
  },
  components: {
    LmSpinnerBorder
  },
  methods: {
    stopPropagation (event) {
      if (this.isDisabled) {
        event.stopPropagation()
      }
    }
  }
}
</script>
<style lang="sass" scoped>
  .btn
    white-space: nowrap
    box-shadow: $button-shadow
  .lm-spinner-border
    position: absolute
    top: 25%
    bottom: 0
    left: 0
    right: 0
    z-index: 9999
    margin: 0 auto
</style>
